export default __webpack_public_path__ + "static/media/news53.f2980ab3.jpg";